import * as actions from "../actions_agent/Type";
const intialState = {
  creating_invoice: {},
  creating_invoice_rent: {},
  sell_contracts: [],
  rent_contracts: [],
  sell_contracts_failed: [],
  rent_contracts_failed: [],
  sell_invoice_obj: {},
  rent_invoice_obj: {},
  tanents_list: [],
  new_takemoney: {},
  list_of_take_money: [],
  list_of_each_tenant: [],
  take_money_view: {},
  view_each_tenant: {},
  recontract_invoice: {},
  list_of_each_take_money: [],
  List_names: [],
  obj_agentId: {},
  obj_rent_agentId: {},
  obj_takeMoney_branchId: "",
  obj_listmoney: {},
  name_takemoney: "",
  agent_tenant: {},
  branch_tenant: {},
  list_take_money_byid: [],
  branch_name: "",
  branch_name_rent: "",
  main_form_rent: {},
  main_form_sell: {},
  create_asaysh: {},
  list_scurety: [],
  scurety_view_obj: {},
  paradan_create_obj: {},
  paradan_lists: [],
  view_paradan_obj: {},
  support_created: {},
  support_created_selected: {},
  vella_created: {},
  vella_contracts: [],
  view_vella_contract: {},
  View_just_vella_obj: {},
  selects: [],
  index_rentcontrct: "",
  index_sell_contract: "",
  index_takemoney: "",
  index_Paradan: "",
  sell_obj_avilabeId: {},
  view_avilable_rent: {},
  /// tenant
  tenant_takemoney: {},
  tenant_paradan: {},
  tenant_contract: {},
  tenant_recontract: {},
  tenant_view_takemoney_arr: [],
  tenant_view_paradan_arr: [],
  tenant_view_contract_arr: [],
  id_tenant_paradan: "",
  id_tenant_contract: "",
  tenant_takemoney_obj: {},
  tenant_payment_obj: {},
  //project
  list_anket_bills: [],
  create_support_project: {},
  project_view_bills: {},
  // writer
  list_writer: [],
  view_writer: {},
  index_write: "",
  // list agent
  list_agents: [],
};
const InvoiceReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.CREATE_CONTRACT:
      return {
        ...state,
        creating_invoice: action.payload,
      };
    case actions.CREATE_CONTRACT_RENT:
      return {
        ...state,
        creating_invoice_rent: action.payload,
      };
    case actions.GET_SELL_CONTRACTS:
      return {
        ...state,
        sell_contracts: action.payload.doc,
        obj_agentId: action.payload.obj,
        branch_name: action.payload.branch_name,
      };
    case actions.GET_SELL_CONTRACTS_FAILED:
      return {
        ...state,
        sell_contracts_failed: action.payload.doc,
      };
    case actions.VIEW_CONTRACT_SELL:
      return {
        ...state,
        sell_invoice_obj: action.payload,
        sell_obj_avilabeId: action.sell_obj_avilabeId,
        index_sell_contract: action.index_sell_contract,
      };

    case actions.GET_RENT_CONTRACTS:
      return {
        ...state,
        rent_contracts: action.payload.doc,
        obj_rent_agentId: action.payload.obj,
        branch_name_rent: action.payload.branch_name_rent,
      };
    case actions.GET_RENT_CONTRACTS_FAILED:
      return {
        ...state,
        rent_contracts_failed: action.payload.doc,
        obj_rent_agentId: action.payload.obj,
        branch_name_rent: action.payload.branch_name_rent,
      };
    case actions.VIEW_CONTRACT_RENT:
      return {
        ...state,
        rent_invoice_obj: action.payload,
        index_rentcontrct: action.index_rentcontrct,
        view_avilable_rent: action.view_avilable_rent,
      };

    case actions.GET_LIST_OF_TANENTS:
      return {
        ...state,
        tanents_list: action.payload.doc,
        agent_tenant: action.payload.agentId,
        branch_tenant: action.payload.branchId,
      };

    case actions.TAKE_MONEY_CREATING:
      return {
        ...state,
        new_takemoney: action.payload,
        list_of_take_money: [action.payload, ...state.list_of_take_money],
      };

    case actions.TAKE_MONEY_LIST:
      return {
        ...state,
        list_of_take_money: action.payload.doc,
        name_takemoney: action.payload.name,
        obj_listmoney: action.payload.obj,
      };

    case actions.TAKE_MONEY_VIEW:
      return {
        ...state,
        take_money_view: action.payload,
        index_takemoney: action.index_takemoney,
      };
    case actions.CREATING_MAIN_RENT_FORM:
      return {
        ...state,
        main_form_rent: action.payload,
        rent_contracts: [action.payload, ...state.rent_contracts],
      };
    case actions.CREATING_MAIN_SELL_FORM:
      return {
        ...state,
        main_form_sell: action.payload,
        sell_contracts: [action.payload, ...state.sell_contracts],
      };
    case actions.CREATING_MAIN_ASAYSH_FORM:
      return {
        ...state,
        create_asaysh: action.payload,
        list_scurety: [action.payload, ...state.list_scurety, action.payload],
      };
    case actions.GET_SCURETY_BILLS:
      return {
        ...state,
        list_scurety: action.payload,
      };
    case actions.VIEW_SCURETY:
      return {
        ...state,
        scurety_view_obj: action.payload,
      };
    case actions.CREATING_MAIN_PARADAN:
      return {
        ...state,
        paradan_create_obj: action.payload,
        paradan_lists: [action.payload, ...state.paradan_lists],
      };
    case actions.GET_PARADAN_LIST:
      return {
        ...state,
        paradan_lists: action.payload,
      };
    case actions.VIEW_PARADAN:
      return {
        ...state,
        view_paradan_obj: action.payload,
        index_Paradan: action.index_Paradan,
      };
    case actions.STATUS_APARTMENT:
      return {
        ...state,
      };
    case actions.CREATE_TAED:
      return {
        support_created: action.payload,
      };
    case actions.CREATE_SELECT_TAED:
      return {
        support_created_selected: action.payload,
      };
    case actions.UPDATE_SELL_CONTRACT:
      return {
        ...state,
      };
    case actions.UPDATE_RENT_CONTRACT:
      return {
        ...state,
      };
    case actions.CREATE_CONTRACT_VELLA:
      return {
        vella_created: action.payload,
      };
    case actions.GET_VELLA_CONTRACTS:
      return {
        ...state,
        vella_contracts: action.payload,
      };
    case actions.VIEW_CONTRACT_VELLA:
      return {
        view_vella_contract: action.payload,
        View_just_vella_obj: action.payload.ViellaId,
        vella_contracts: [],
      };

    case actions.STATUS_VELLA:
      return {
        ...state,
      };
    case actions.UPDATE_PARADAN:
      return {
        ...state,
      };
    case actions.UPDATE_TAKEMONEY:
      return {
        ...state,
      };
    case actions.TAKE_MONEY_TENANTCREATING:
      return {
        ...state,
        tenant_takemoney: action.payload,
      };
    case actions.VIEW_TENANT_TAKYMONEY:
      return {
        ...state,
        tenant_view_takemoney_arr: action.payload,
        tenant_takemoney_obj: action.tenant_takemoney_obj,
      };
    case actions.PARADAN_TENANTCREATING:
      return {
        ...state,
        tenant_paradan: action.payload,
      };
    case actions.VIEW_TENANT_PARADAN:
      return {
        ...state,
        tenant_view_paradan_arr: action.payload,
        id_tenant_paradan: action.id_tenant_paradan,
        tenant_payment_obj: action.tenant_payment_obj,
      };
    case actions.VIEW_TENANT_CONTRACT:
      return {
        ...state,
        tenant_view_contract_arr: action.payload,
        id_tenant_contract: action.id_tenant_contract,
      };
    case actions.CONTRACT_TENANTCREATING:
      return {
        ...state,
        tenant_contract: action.payload,
      };
    case actions.TENANT_RECONTRACT_CREATING:
      return {
        ...state,
        tenant_recontract: action.payload,
      };
    case actions.CREATING_SUPPORT_PROJECT:
      return {
        ...state,
        create_support_project: action.payload,
      };
    case actions.GET_ANKET_BILLS:
      return {
        ...state,
        list_anket_bills: action.payload,
      };
    case actions.VIEW_PROJECT_BILLS:
      return {
        ...state,
        project_view_bills: action.payload,
      };
    case actions.CREATEING_FORM_WRITERS:
      return {
        ...state,
      };
    case actions.GET_WRITERS_LIST:
      return {
        ...state,
        list_writer: action.payload,
      };
    case actions.VIEW_WRITORS:
      return {
        ...state,
        view_writer: action.payload,
        index_write: action.index_write,
      };
    case actions.GET_LIST_AGENTS:
      return {
        ...state,
        list_agents: action.payload,
      };
    case actions.DELETE_SELL:
      return {
        ...state,
        sell_contracts: state.sell_contracts.filter(
          (el) => el._id !== action.sell_id
        ),
        sell_contracts_failed: state.sell_contracts.filter(
          (el) => el._id !== action.sell_id
        ),
      };
    case actions.DELETE_RENT:
      return {
        ...state,
        rent_contracts: state.rent_contracts.filter(
          (el) => el._id !== action.rent_id
        ),
        rent_contracts_failed: state.rent_contracts_failed.filter(
          (el) => el._id !== action.rent_id
        ),
      };
    case actions.DELETE_TAKEMONEY:
      return {
        ...state,
        list_of_take_money: state.list_of_take_money.filter(
          (el) => el._id !== action.id
        ),
      };
    case actions.DELETE_PARADAN:
      return {
        ...state,
        paradan_lists: state.paradan_lists.filter((el) => el._id !== action.id),
      };
    case actions.SCURETY_DELETE:
      return {
        ...state,
        list_scurety: state.list_scurety.filter((el) => el._id !== action.id),
      };
    case actions.SCURITY_UPDATE:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
};

export default InvoiceReducer;
